import React, { useState, useEffect, useContext } from 'react';
import HelpSiteService from "../../Controller/Configuration/HelpSiteController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateHelpSite from './CreateHelpSite';
import Common from '../../../Common/Common';
import Swal from 'sweetalert2';
function HelpSiteListPage() {
    const navigate = useNavigate();
    const [subFormList, setSubFormList] = useState([]);
    const [formList, setFormList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [modalInstance, setModalInstance] = useState(null);
    const [currentForm, setCurrentFOrm] = useState(null);
    const [formData, setFormData] = useState({ ModuleID: "0" });
    useEffect(() => {
        fetchSubForms();
        fetchForms();
    }, []);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('helpSiteModal')));
    }, []);

    const fetchSubForms = async (FormID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await HelpSiteService.GetSubFormByFormID(redirectCallback, FormID);
            setSubFormList(list);
            setCurrentFOrm(null);
        } catch (error) {
            console.error('Error fetching Asset Sub Categories:', error);
        }
    };

    const fetchForms = async () => {
        try {
            let list = await HelpSiteService.GetForms();
            list = list.filter(x => x.ID != 35 && x.ID != 36 && x.ID != 32);
            setFormList(list);
        } catch (error) {
            console.error('Error fetching Asset Categories:', error);
        }
    };

    const handleCreateClick = async () => {
        setCurrentFOrm(null);

        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        setCurrentFOrm(null);
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const handleEditClick = async (asset) => {
        setCurrentFOrm(asset); // Set the asset subcategory to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };
    const handleChange = async (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        if (name === 'ModuleID') {
            fetchSubForms(value);
        }
    };
    const handleSuccess = () => {
        fetchSubForms(formData.ModuleID);
        handleCloseModal();   // Close the modal
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await HelpSiteService.DeleteHelpLink(ID, redirectCallback)
                    fetchSubForms(formData.ModuleID)
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    return (
        <div>
            <Common />
            <div className="main-content-header">
                <h1>Help Link</h1>
            </div>
            <div className="row mb-3">
                <div className="col-sm-2">
                    Select Module
                </div>
                <div className="col-sm-4">
                    <select name="ModuleID" className="form-control" onChange={handleChange} value={formData.ModuleID}>
                        <option value="0">Select Module</option>
                        {formList.map((form) => (
                            <option key={form.ID} value={form.ID}>
                                {form.FormName}
                            </option>
                        ))}
                    </select>
                </div>

            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table m-0 table-hover">
                                    <thead>
                                        <tr>

                                            <th>Form Name</th>

                                            <th>Help Site</th>
                                            <th style={{ "textAlign": "right" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {subFormList.map((asset, index) => (

                                            <tr key={asset.ID}>

                                                <td>{asset.SubForm}</td>

                                                <td>{asset.HelpSite}</td>
                                                <td style={{ "textAlign": "right" }}>
                                                    <button className='text-info' style={{ "background": "none", "border": "none" }} onClick={() => handleEditClick(asset)}>
                                                        <i className="icofont-edit" aria-hidden="true"></i>
                                                    </button>
                                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, asset.ID)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CreateHelpSite
                form={currentForm}
                onClose={handleCloseModal}
                onSuccess={handleSuccess}
                formList={formList}
            />
        </div>
    );
}

export default HelpSiteListPage;
